module.exports = __webpack_public_path__ + "static/img/feedbacck-left-ico-index.e2aec4c6.png";